import { TrayMapSelectorProps } from './TrayMapSelector.types'
import GrayScale from '../GrayScale/GrayScale'
import useDTMS3Image from 'lib/utils/useDTMS3Image'
import CustomImplantTray from '../CustomImplantTray/CustomImplantTray'

const TrayMapSelector: React.FC<TrayMapSelectorProps> = ({
  trayType,
  mapContent,
  isInOR = false,
  loadWithUDIs = true,
  onClickActions,
  isScrewEnabled,
  isScrewImplanted,
  isScrewWasted,
  handlePlateUsage,
  getPlateCount,
  setSelectedPlate,
  setModalOpen,
  setSelectedScrew,
  hideButton = false,
  isSPD = false,
  trayImg,
  screwsRemovedByNurse,
  nurseUsageHistory,
  templateData: initialTemplateData,
}) => {
  const { imageUrl: signedTrayImg, isLoading: isImageLoading } = useDTMS3Image({
    url: trayImg,
    defaultImage: '',
  })

  if (trayType === 'instrument') {
    return isImageLoading ? (
      <div
        className="instrument-tray-img-skeleton"
        style={{
          width: '100%',
          height: '300px',
          borderRadius: '12px',
          backgroundColor: '#f0f0f0',
        }}
      />
    ) : (
      <img
        className="instrument-tray-img"
        src={signedTrayImg}
        alt="Instrument Tray"
        style={{ width: '100%', objectFit: 'cover', borderRadius: '12px' }}
      />
    )
  }

  if (trayType === 'custom implants') {
    return <CustomImplantTray isInOR={isInOR} />
  }

  return (
    <GrayScale
      isInOR={isInOR}
      setSelectedPlate={setSelectedPlate}
      setModalOpen={setModalOpen}
      hideButton={hideButton}
      trayType={trayType}
      setSelectedScrew={setSelectedScrew}
      isScrewEnabled={isScrewEnabled}
      isScrewImplanted={isScrewImplanted}
      isScrewWasted={isScrewWasted}
      getPlateCount={getPlateCount}
      mapContent={mapContent}
      isSPD={isSPD}
      screwsRemovedByNurse={screwsRemovedByNurse}
      nurseUsageHistory={nurseUsageHistory}
      templateData={initialTemplateData}
    />
  )
}

export default TrayMapSelector
